/**
 * ダイスシンボル用のロール関数
 * @param faces : ダイスの種類
 * @returns
 */
export const rollDiceSymbol = (faces: number): number => {
  const result = Math.floor(Math.random() * faces) + 1;
  return result;
};
